<template>
  <div class="purchase-panel">
    <div class="purchase-chart">
      <div class="c-order-util-box">
        <div class="left-box">
          <div class="text-item">
            <strong> 총 매입금액 </strong>
            <span>
              {{ Number(data.biz1.totalSum).toLocaleString() }}원 (VAT 포함)
            </span>
          </div>
        </div>
        <div class="right-box">
          <div class="text-item">
            <span>
              {{ data.biz1.search.chartDateSt }} ~
              {{ data.biz1.search.chartDateEd }}
            </span>
          </div>
        </div>
      </div>
      <!-- D: 차트 영역(chart-box div 살려야합니다) -->
      <div class="chart-box">
        <canvas ref="chartCanvas2"></canvas>
      </div>
      <!-- // D: 차트 영역(chart-box div 살려야합니다) -->
    </div>
  </div>
</template>
<script setup name="purchaseListTab">
import * as store from "@/store";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";
const { isMobile } = cmUtil.useDeviceType();
import { Chart } from "chart.js";
import {
  computed,
  inject,
  onMounted,
  onUnmounted,
  reactive,
  ref,
  nextTick,
} from "vue";
import { api } from "@/plugins/api";

const url = inject("url_prefix");

const todayDate = computed(() => {
  const now = new Date();
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  return now.toLocaleDateString("en-CA", options);
});

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {
    token: "",
    isLogin: false,
    userLoginInfo: {},
    deviceType: isMobile.value ? "M" : "P",
    basketCount: {},
    empIndex: 0,
    selectedBranch: {},
  },
  codes: {
    code01: [],
    code02: [],
  },
  popup: {},
  biz1: {
    search: {
      fkdatSt: "", // 시작 매입일자
      fkdatEd: "", // 끝 매입일자
      searchQuery: "", // 검색어
      useYn: "Y",
      orderBy: "",
      chartDateSt: "",
      chartDateEd: "",
      resDateSt: "",
      resDateEd: "",
    },
    search_init: {}, // 검색 파라메터 초기값
    list: [], // 목록
    page: 0, // 현재 페이지
    limit: 20, // 목록 조회 행수
    totalCount: 0,
    totalPage: 0,
    totalSum: 0,
    chartRangeYear: [],
    chartRangeMonth: [],
    chartData: [],
    yearMonth: "",
    loading: false,
  },
  eventBus: {
    salesPersonIndex: 0,
  },
});

let chartInstance = null;
const chartCanvas2 = ref(null);

/**********************
 * 마운트
 *********************/
onMounted(() => {
  pageInit(); // 페이지 초기화 호출
});

onUnmounted(() => {
  destroyChart();
});
/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  await pageInitData();
  await searchCmd("biz1#graph"); // 출고현황 그래프 데이터
  await nextTick();
  createGraph(); // 출고현황 그래프
}

/**********************
 * 페이지 초기 데이타 조회
 *********************/
async function pageInitData() {
  // ◼◼◼ 초기데이타 조회
  const mparm = [];
  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message} `);
    return false;
  }

  data.page.token = cmUtil.getLocalStorage("token");
  data.page.isLogin = store.useAuthStore()?.user ? true : false;
  data.page.userLoginInfo = store.useAuthStore()?.user;

  // 영업사원 디폴트
  data.page.empIndex = store.useEventBusStore()?.salesPersonIndex;
  data.page.selectedBranch =
    data.page.userLoginInfo.empList[data.page.empIndex];

  dateCalculation("defaultYear", "chart");

  // ◼◼◼ 초기데이타 백업
  data.biz1.search_init = { ...data.biz1.search };
}

/**********************
 * 조회 모음
 *********************/
async function searchCmd(cmd = "", parms = {}) {
  if (cmd === "biz1#graph") {
    const res = await api.get(`${url}/order/selectPurchaseGraph`);
    const { totalSum } = res.data.find((item) => item.fkdatYear == null);
    data.biz1.totalSum = totalSum;
    data.biz1.list = res.data.filter((item) => item.fkdatYear != null);
    data.biz1.chartRangeYear = data.biz1.list.map((item) => item.fkdatYear);
    data.biz1.chartRangeMonth = data.biz1.list.map((item) => item.fkdatMonth);
    data.biz1.chartData = data.biz1.list.map((item) => {
      return {
        x: item.fkdatMonth,
        y: item.totalSum,
        year: item.fkdatYear,
      };
    });
    if (isMobile.value) {
      data.biz1.chartRangeYear = data.biz1.chartRangeYear.slice(-6);
      data.biz1.chartRangeMonth = data.biz1.chartRangeMonth.slice(-6);
      data.biz1.chartData = data.biz1.chartData.slice(-6);
    }
  } else {
    alert(`[개발확인] searchCmd() cmd [${cmd}] 를 확인해주세요` + parms);
    return false;
  }
}

// 검색 기간 계산
async function dateCalculation(period, type) {
  const today = new Date();
  let resultDate = new Date(today);
  switch (period) {
    case "today":
      resultDate.setDate(today.getDate());
      break;
    case "month":
      resultDate.setDate(today.getDate() - 29);
      break;
    case "half-year":
      resultDate.setDate(today.getDate() - 179);
      break;
    case "year":
      resultDate.setDate(today.getDate() - 364);
      break;
    case "defaultYear":
      resultDate.setDate(today.getDate() - 364);
      //resultDate.setDate(1);
      break;
    default:
      await cmUtil.alert("알 수 없는 기간입니다.");
      return null;
  }

  // YYYY-MM-DD 형식으로 변환
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  resultDate = resultDate.toLocaleDateString("en-CA", options);
  if (type == "chart") {

    var year = resultDate.substring(0,4);
    var month = resultDate.substring(5,7);
  
    if (isMobile.value) {
      month = Number(month) + 7;
    }else{
      month++;
    }

    if(month>12){year = year+1; month = 1; }
    
    if (("" + month).length == 1) { month = "0" + month; }
   
    data.biz1.search.chartDateSt = "" + year +"-"+ month+ "-" + '01';
    data.biz1.search.chartDateEd = todayDate.value;
  } else {
    data.biz1.search.fkdatSt = resultDate;
    data.biz1.search.fkdatEd = todayDate.value;
  }
}

// 매입현황 그래프
function createGraph() {
  destroyChart();
  if (!chartCanvas2.value) {
    return;
  }
  const ctx = chartCanvas2.value?.getContext("2d");
  if (!ctx) return;

  try {
    chartInstance = new Chart(ctx, {
      type: "bar",
      data: {
        labels: data.biz1.chartRangeMonth,
        datasets: [
          {
            data: data.biz1.chartData,
            backgroundColor: (context) => {
              return context.dataIndex === context.dataset.data.length - 1
                ? "#007D6C"
                : "#C8EFE5";
            },
            hoverBackgroundColor: (context) => {
              return context.dataIndex === context.dataset.data.length - 1
                ? "#007D6C"
                : "#C8EFE5";
            },
            borderRadius: 30,
            barThickness: 20,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: isMobile.value
            ? {// 250408 변경
                top: 40,
                bottom: 20,
                left: 16,
                right: 16,
              }
            : {// 250408 변경
                top: 40,  
                bottom: 40,
                left: 40,
                right: 40,
              },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            position: "average",
            yAlign: "bottom",
            caretPadding: 10,
            backgroundColor: "#FFECEC",
            titleColor: "#FF7A7A",
            bodyColor: "#FF7A7A",
            borderColor: "#FFCECE",
            borderWidth: 1,
            padding: 6,
            displayColors: false,
            titleFont: {
              weight: "bold",
            },
            bodyFont: {
              weight: "bold",
            },
            callbacks: {
              title: function (context) {
                const month = context[0].label;
                const year = context[0].raw.year;
                return `${year}년 ${month}월`;
              },
              label: function (context) {
                const value = context.raw;
                return `${value.y.toLocaleString()}원`;
              },
            },
          },
        },
        scales: {
          x: {
            grid: {
              display: false,
            },
            border: {
              display: false,
            },
            ticks: {
              maxRotation: 0,
              minRotation: 0,
              autoSkip: true,
              autoSkipPadding: 10,
              color: "#000000",
              font: {
                size: 15,
              },
            },
          },
          y: { // 250408 y축 옵션 변경
            beginAtZero: true,
            ticks: {
              color: '#000000'
            },
          },
        },
        elements: {
          bar: {
            borderSkipped: false,
          },
        },
        onClick(event, chartElement) {
          if (chartElement.length > 0) {
            const clickedData = chartElement[0].element.$context.raw;
            store
              .usePurchaseListStore()
              .setParam({ year: clickedData.year, month: clickedData.x });
            store.usePurchaseListStore().excuteSearchFunction();
          }
        },
      },
    });
  } catch (error) {
    console.log("cahrt", error);
  }
}

function destroyChart() {
  if (chartInstance) {
    try {
      chartInstance.destroy();
      chartInstance = null;
    } catch (error) {
      console.log("destroyChart", error);
    }
  }
}
</script>
